import styled from "styled-components";
import Colors from "../../global/color.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: flex-end;
  text-decoration: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;

const Overlay = styled.a`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 8e-5) 35.03%,
    rgba(0, 0, 0, 0.0533333) 48.04%,
    rgba(0, 0, 0, 0.169412) 59.79%,
    rgba(0, 0, 0, 0.326275) 70.29%,
    rgba(0, 0, 0, 0.492549) 79.54%,
    rgba(0, 0, 0, 0.646275) 87.58%,
    rgba(0, 0, 0, 0.756078) 94.39%,
    rgba(0, 0, 0, 0.8) 100%
  );
  &:hover {
    cursor: pointer;
  }
`;

const StyledContainer = styled.div`
  max-width: 630px;
  padding: 16px;
  z-index: 1;
`;

const StyledCategory = styled.div`
  font-family: FuturaPT-Book;
  font-family: FuturaPT-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-decoration: none;
  display: block;
  &:hover {
    text-decoration: none;
  }
  color: #fafafa;
`;

const StyledTitle = styled.div``;

const StyledRow = styled.div`
  display: flex;
  margin-top: 11px;
  align-items: center;
`;

const StyledLink = styled.a`
  font-family: Ogg-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 30px;
  letter-spacing: 1px;
  color: #ffffff;
  text-decoration: none;
  &:hover {
    text-decoration: underline ${Colors.gold};
  }
`;

const StyledDate = styled.div`
  font-family: FuturaPT-Book;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #fafafa;
`;

const StyledCaption = styled.div``;

const StyledBody = styled.div``;

const StyledBar = styled.div`
  margin: 0px 15px;
  color: #fafafa;
`;

export {
  Container,
  StyledContainer,
  StyledLink,
  StyledDate,
  StyledCategory,
  StyledTitle,
  StyledCaption,
  StyledBody,
  StyledRow,
  StyledBar,
  Overlay,
};
